/**
 * Custom Site Specific Page
 *
 * Site-scoped extension of the shared Page component. Used to inject
 * site-specific content/behavior without modifying common assets.
 *
 * @extends Page
 */
import { Page } from "commonAssets/pages/Page";
import { faqsPage } from "commonAssets/pages/Page/faqs";

export class CustomPage extends Page {
    /**
     * Renders the FAQs page after applying site-specific section content.
     *
     * The shared FAQs renderer pulls section content from the CMS/appDocket.
     * This site requires a specific lead paragraph for the "Excluding Yourself
     * from the Settlement" section, which is injected here before render so the
     * substitution lives in site scope rather than in the shared component.
     *
     * @param {Function} [render=faqsPage] - The render function for the FAQs page.
     * @param {Array<Function>} [plugin=[]] - An array of plugin functions.
     */
    faqs(render = faqsPage, plugin = []) {
        injectExclusionSectionLead(this);
        render(this);
        plugin.forEach((plugin) => plugin(this));
    }
}

/**
 * Sets the lead paragraph for the "Excluding Yourself from the Settlement"
 * FAQ section on the current page, matching the previously hardcoded copy.
 *
 * @param {CustomPage} page - The current page instance.
 */
function injectExclusionSectionLead(page) {
    const faqsPageData = page.pages.find((p) => p.PageName === page.slug);
    if (!faqsPageData || !Array.isArray(faqsPageData.PageContent)) {
        return;
    }
    faqsPageData.PageContent.forEach((section) => {
        if (section.SectionTitle === "Excluding Yourself from the Settlement") {
            section.SectionLead =
                "<p>If you are a Settlement Class member and want to keep any right you may have to sue or continue to sue the Defendant and/or the other Released Parties on your own based on the claims raised in this Action or released by the Released Claims, then you must take steps to get out of the Settlement. This is called excluding yourself from—or “opting out” of—the Settlement. Any Class Member who does not file a timely Request for Exclusion in accordance with the instructions below will lose the opportunity to exclude himself or herself from the Settlement and will be bound by the Settlement.</p>";
        }
    });
}
